import { render, staticRenderFns } from "./_bulk_add_folders_modal.vue?vue&type=template&id=13212b48&scoped=true&"
import script from "./_bulk_add_folders_modal.vue?vue&type=script&lang=js&"
export * from "./_bulk_add_folders_modal.vue?vue&type=script&lang=js&"
import style0 from "./_bulk_add_folders_modal.vue?vue&type=style&index=0&id=13212b48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13212b48",
  null
  
)

export default component.exports